import "./invoices.styles.scss";
import { useContext, useEffect, useState } from "react";
import { InvoicesContext } from "../../contexts/invoices.context";
import Filter from "../../components/filter/filter.component";
import LargeTable from "../../components/large-table/large-table.component";
import InvoiceExportBar from "../../components/invoice-export-bar/invoice-export-bar.component";

const defaultFormFields = {
  sort: "number",
  direction: "desc",
};

const invoiceFields = [
  { label: "Created", value: "created_at" },
  { label: "Updated", value: "updated_at" },
  { label: "Ticket", value: "ticket_number" },
];

const Invoices = () => {
  const { fetchInvoices } = useContext(InvoicesContext);
  const [invoices, setInvoices] = useState([]);
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { sort, direction } = formFields;
  const [results, setResults] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    fetchInvoices(sort, direction).then((res) => {
      setInvoices(res);
    });
  }, [sort, direction]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((existing) => existing !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = (items, shouldSelect) => {
    const ids = items.map((item) => item._id);
    setSelectedIds((prev) =>
      shouldSelect
        ? Array.from(new Set([...prev, ...ids]))
        : prev.filter((id) => !ids.includes(id))
    );
  };

  const displayedInvoices = results ? results : invoices;

  return (
    <div className="invoices index-container">
      <Filter
        handleChange={handleChange}
        formFields={formFields}
        searchData={invoices}
        searchType={"invoices"}
        results={setResults}
      />
      <InvoiceExportBar selectedIds={selectedIds} />
      <LargeTable
        array={displayedInvoices}
        tableName="Invoices"
        keyValue="_id"
        label="number"
        fields={invoiceFields}
        selectable
        selectedIds={selectedIds}
        onToggleSelect={toggleSelect}
        onToggleSelectAll={toggleSelectAll}
      />
    </div>
  );
};

export default Invoices;
